import axios from 'axios'
export default {
  state: {
    user: {},
  },
  getters: {
    user: (s) => s.user,
  },
  mutations: {
    updateSession(state, session) {
      if (session && Object.keys(session).length) {
        state.user = { ...state.user, ...session }
      } else {
        state.user = session
      }
    },
    updatePhoto(state, photo) {
      state.user.photo = photo
    },
    updateInvites(state, invites) {
      state.user.invites = invites
    },
  },
  actions: {
    fetchLocale(ctx, lang) {
      return axios({
        method: 'POST',
        url: 'api/user/user-lang',
        data: 'lang=' + lang,
      })
        .then(async () => {
          await ctx.dispatch('fetchSession')
        })
        .catch((error) => {
          console.error(error)
        })
    },
    fetchSession(ctx) {
      return axios({
        method: 'GET',
        url: 'api/user/',
      })
        .then((response) => {
          const session = response.data.result
          ctx.commit('updateSession', session)
          ctx.dispatch('fetchInvite')
          return true
        })
        .catch((error) => {
          console.error(error)
          return false
        })
    },
    clearSession(ctx) {
      ctx.commit('updateSession', {})
    },
    fetchChangeUserData(ctx, data) {
      const formData = new FormData()
      for (let key in data) {
        formData.append(key, data[key])
      }
      return axios({
        method: 'POST',
        url: 'api/user/',
        data: formData,
      })
        .then((response) => {
          const user = response.data
          ctx.commit('updateSession', user.result)
          return true
        })
        .catch((error) => {
          console.error(error)
        })
    },
    fetchChangeUserPhoto(ctx, data) {
      return axios({
        method: 'POST',
        url: 'api/user/photo',
        data: data,
      })
        .then((response) => {
          const userPhoto = response.data
          ctx.commit('updatePhoto', userPhoto.result.photo)
        })
        .catch((error) => {
          console.error(error)
        })
    },
    sendEmailConfirmCode(ctx, data) {
      const fd = new FormData()
      fd.append('email', data)
      return axios({
        method: 'POST',
        url: '/api/auth/login/email/send/',
        data: fd,
      })
        .then(() => {
          return true
        })
        .catch((error) => {
          console.error(error)
          return false
        })
    },
    sendEmailConfirm(ctx, { id, email, pin }) {
      const fd = new FormData()
      fd.append('email', email)
      fd.append('pin', pin)
      return axios({
        method: 'POST',
        url: `/api/auth/login/${id}/email/confirm/`,
        data: fd,
      })
        .then(() => {
          return true
        })
        .catch((error) => {
          console.error(error)
          return false
        })
    },
    changePassword(ctx, { password, password_repeat }) {
      const fd = new FormData()
      fd.append('new_password1', password)
      fd.append('new_password2', password_repeat)
      return axios({
        method: 'POST',
        url: `/api/auth/password-change/`,
        data: fd,
      })
        .then(() => {
          return true
        })
        .catch((error) => {
          console.error(error)
          return error.response.data.result.new_password2[0].code
        })
    },
    fetchUserCertificat(ctx, data) {
      let formData = new FormData()
      formData.append('certificates', [data])
      return axios({
        method: 'POST',
        url: 'api/user/certificates',
        data: formData,
      })
        .then(() => {
          // console.log(response)
          // const user = response.data
          ctx.dispatch('fetchSession')
          return true
        })
        .catch((error) => {
          console.error(error)
        })
    },
    fetchInvite(ctx) {
      return axios({
        method: 'GET',
        url: 'api/user/invites',
      })
        .then((response) => {
          const invites = response.data || []
          ctx.commit('updateInvites', invites)
          return true
        })
        .catch((error) => {
          console.error(error)
          return false
        })
    },
  },
}
